/* tslint:disable */

/**
 */
export class DatabaseBackup {
    key?: string;
}
